import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, CrownIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`w-full transition-all duration-300 ${isScrolled ? 'bg-cream shadow-md py-3' : 'bg-transparent py-5 absolute top-full left-0 right-0'}`} data-id="element-234">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
        <div className="flex justify-between items-center" data-id="element-236">
          <Link to="/" className="flex items-center gap-3 group z-50" data-id="element-237">
            <CrownIcon className="w-8 h-8 text-brand-gold" data-id="element-238" />
            <div className="flex flex-col" data-id="element-239">
              <span className={`font-display italic text-4xl lowercase tracking-wider leading-none ${isScrolled ? 'text-near-black' : 'text-cream'}`} data-id="element-240">
                rozii
              </span>
              <span className={`font-body text-[0.6rem] uppercase tracking-[0.2em] font-bold mt-1 ${isScrolled ? 'text-near-black/70' : 'text-cream/70'}`} data-id="element-241">
                African Hair Braiding
              </span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center space-x-8" data-id="element-242">
            {['Home', 'Services', 'Price List', 'About', 'Gallery', 'Contact'].map(item => <Link key={item} to={item === 'Home' ? '/' : `/${item.toLowerCase().replace(' ', '-')}`} className={`text-sm uppercase tracking-widest font-medium transition-colors hover:text-brand-gold ${isScrolled ? 'text-near-black' : 'text-cream'}`} data-id="element-243">
                {item}
              </Link>)}
            <a href="tel:2409217857" className="px-6 py-2.5 rounded-full bg-brand-gold text-cream hover:bg-near-black text-sm uppercase tracking-widest font-bold transition-all flex items-center gap-2 shadow-md" data-id="element-244">
              Call to Book <span className="text-lg leading-none" data-id="element-245">→</span>
            </a>
          </nav>

          <button className={`lg:hidden p-2 z-50 ${isScrolled ? 'text-near-black' : 'text-cream'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-246">
            {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-247" /> : <MenuIcon className="h-6 w-6" data-id="element-248" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-249">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="absolute top-full left-0 right-0 bg-cream shadow-xl border-t border-warm-brown/10 lg:hidden overflow-hidden" data-id="element-250">
            <div className="flex flex-col px-6 py-8 space-y-6" data-id="element-251">
              {['Home', 'Services', 'Price List', 'About', 'Gallery', 'Contact'].map(item => <Link key={item} to={item === 'Home' ? '/' : `/${item.toLowerCase().replace(' ', '-')}`} onClick={() => setIsMobileMenuOpen(false)} className="text-xl font-display italic text-warm-brown hover:text-brand-gold transition-colors" data-id="element-252">
                  {item}
                </Link>)}
              <div className="pt-4" data-id="element-253">
                <a href="tel:2409217857" className="flex items-center justify-center gap-2 w-full text-center px-6 py-4 rounded-full bg-brand-gold text-cream font-bold uppercase tracking-widest text-sm hover:bg-near-black transition-colors shadow-md" data-id="element-254">
                  Call to Book <span data-id="element-255">→</span>
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}